import { Directive, Input, TemplateRef, ViewContainerRef, inject, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { TokenStorageService } from '../services/token-storage.service';

@Directive({
    selector: '[hasFeature]',
    standalone: true
})
export class HasFeatureDirective implements OnInit {
    @Input('hasFeature') expectedFeature!: string;

    private templateRef = inject(TemplateRef);
    private viewContainer = inject(ViewContainerRef);
    private dataService = inject(DataService);
    private tokenService = inject(TokenStorageService);

    ngOnInit() {
        if (this.tokenService) {
            const user = this.tokenService.getUser();
            if (user) {
                this.dataService.getFeature(this.expectedFeature).subscribe(feature => {
                    if (feature?.enabled) {
                        this.viewContainer.createEmbeddedView(this.templateRef);
                    } else {
                        this.viewContainer.clear();
                    }
                });
            }
        }
    }
}